module.exports = __webpack_public_path__ + "img/service-3.29f675f2.jpg";